export default "__VITE_ASSET__Bq6unDdJ__"